import React, { useEffect, useState } from 'react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import kct_logo from './assets/stakelogo.svg';
import { RecoilRoot } from 'recoil';
import { createRoot, hydrateRoot } from 'react-dom/client';
import {
	WagmiConfig,
	createClient,
	defaultChains,
	configureChains,
	chainId,
} from 'wagmi';
import { publicProvider } from 'wagmi/providers/public';
import { Web3AuthConnector } from '@web3auth/web3auth-wagmi-connector';
import { MetaMaskConnector } from 'wagmi/connectors/metaMask';
import { WalletConnectConnector } from 'wagmi/connectors/walletConnect';
const { chains, provider, webSocketProvider } = configureChains(defaultChains, [
	publicProvider(),
]);
export const clientId = process.env.REACT_APP_WEB3AUTH_CLIENTID;
const isMainNet =
	process.env.REACT_APP_CHAIN_TARGET === 'ethereum' ? true : false;
export const walletConnectConnector = new WalletConnectConnector({
	chains: [isMainNet ? chains[0] : chains[3]],
	options: {
		qrcode: true,
	},
});
export const metamaskConnector = new MetaMaskConnector({
	chains: [isMainNet ? chains[0] : chains[3]],
});
export const web3AuthConnector = new Web3AuthConnector({
	chains: [
		{
			id: isMainNet ? 1 : 5,
			name: isMainNet ? 'Ethereum' : 'Goerli',
			network: isMainNet ? 'homestead' : 'goerli',
			rpcUrls: {
				default: process.env.REACT_APP_ALCHEMY_URL,
			},
			testnet: isMainNet ? false : true,
			blockExplorers: {
				default: isMainNet
					? 'https://etherscan.io/'
					: 'https://goerli.etherscan.io/',
			},
		},
	],
	options: {
		uxMode: 'redirect',
		enableLogging: false,
		clientId,
		storageKey: 'session',
		network: isMainNet ? 'mainnet' : 'testnet',
		chainId: isMainNet ? '0x1' : '0x5',
		uiConfig: {
			appLogo: kct_logo,
			loginMethodConfig: {
				google: {
					name: 'GOOGLE',
					description: 'GOOGLE LOGIN',
				},
				apple: {
					name: 'APPLE',
					description: 'APPLE LOGIN',
				},
				twitter: {
					name: 'TWITTER',
					description: 'TWITTER LOGIN',
				},
				facebook: {
					mainOption: false,
					showOnMobile: false,
					showOnModal: false,
					showOnDesktop: false,
				},
				reddit: {
					mainOption: false,
					showOnMobile: false,
					showOnModal: false,
					showOnDesktop: false,
				},
				discord: {
					mainOption: false,
					showOnMobile: false,
					showOnModal: false,
					showOnDesktop: false,
				},
				twitch: {
					mainOption: false,
					showOnMobile: false,
					showOnModal: false,
					showOnDesktop: false,
				},
				line: {
					mainOption: false,
					showOnMobile: false,
					showOnModal: false,
					showOnDesktop: false,
				},
				github: {
					mainOption: false,
					showOnMobile: false,
					showOnModal: false,
					showOnDesktop: false,
				},
				kakao: {
					mainOption: false,
					showOnMobile: false,
					showOnModal: false,
					showOnDesktop: false,
				},
				linkedin: {
					mainOption: false,
					showOnMobile: false,
					showOnModal: false,
					showOnDesktop: false,
				},
				weibo: {
					mainOption: false,
					showOnMobile: false,
					showOnModal: false,
					showOnDesktop: false,
				},
				wechat: {
					mainOption: false,
					showOnMobile: false,
					showOnModal: false,
					showOnDesktop: false,
				},
				email_passwordless: {
					mainOption: true,
					showOnMobile: true,
					showOnModal: true,
					showOnDesktop: true,
				},
			},
			loginMethodsOrder: ['google', 'twitter', 'apple'],
		},

		// redirectUrl: process.env.REACT_APP_WEB3AUTH_REDIRECT_URL
	},
});
export const connectors = [
	web3AuthConnector,
	metamaskConnector,
	walletConnectConnector,
];
export const web3AuthInstance = web3AuthConnector.web3AuthInstance;
export const web3AuthModal = web3AuthConnector.loginModal;
// Set up client
const client = createClient({
	provider,
	webSocketProvider,
	connectors,
});

const root = createRoot(document.getElementById('root'));
const container = (
	<>
		<WagmiConfig client={client}>
			<RecoilRoot>
				<App />
			</RecoilRoot>
		</WagmiConfig>
	</>
);

const element = root.render(container);
if (root.hasChildNodes !== undefined && root.hasChildNodes()) {
	// ReactDOM.hyderate(element,root);
	hydrateRoot(root);
} else {
	// ReactDOM.render(element,root);
	root.render(container);
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
